import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, Observable, throwError } from 'rxjs';
import { ErrorNotificationService } from '../../shared/services/error-notification-service/error-notification.service';

const getErrorMessage = (error: HttpErrorResponse): string | null => {
  if (error.status === 0) {
    return 'Сервис временно недоступен. Проверьте соединение и попробуйте позже.';
  }

  if (error.status === 400) {
    return 'Введённые данные содержат ошибку. Проверьте их и повторите попытку.';
  }

  if (error.status === 401) {
    return 'Необходима авторизация. Войдите в аккаунт повторно.';
  }

  if (error.status === 403) {
    return 'Недостаточно прав для выполнения операции.';
  }

  if (error.status === 404) {
    return 'Запрашиваемые данные не найдены.';
  }

  if (error.status === 409) {
    return 'Не удалось сохранить изменения. Обновите страницу и повторите действие.';
  }

  if (error.status === 413) {
    return 'Не удалось загрузить файл. Превышен допустимый размер.';
  }

  if (error.status === 422) {
    return 'Не удалось обработать введённые данные. Проверьте правильность заполнения.';
  }

  if (error.status === 429) {
    return 'Достигнут лимит запросов. Попробуйте снова через некоторое время.';
  }

  if (error.status >= 500) {
    return 'Произошла ошибка на сервере. Обновите страницу и повторите попытку.';
  }

  return null;
};

export const errorHandlerInterceptor: HttpInterceptorFn = (
  request: HttpRequest<unknown>,
  nextHandler: HttpHandlerFn,
): Observable<HttpEvent<unknown>> => {
  const errorNotificationService = inject(ErrorNotificationService);

  return nextHandler(request).pipe(
    catchError((error: HttpErrorResponse): Observable<never> => {
      const message = getErrorMessage(error);
      const isLoginUnauthorizedError =
        error.status === 401 && request.url.includes('/api/v1/auth/dispatcher');
      const isDestinationNotFoundError =
        error.status === 404 && request.url.includes('/api/v1/missions/destinations/find');
      const isExecutorTimeslotsRequest =
        (request.url.includes('/api/v1/missions/executors/') &&
          request.url.endsWith('/timeslots')) ||
        request.url === '/api/v1/missions/timeslots';
      const isExpectedExecutorTimeslotsError =
        (error.status === 400 || error.status === 404 || error.status === 503) &&
        isExecutorTimeslotsRequest;
      const isMissionTimeslotRequest =
        request.method === 'GET' &&
        request.url.includes('/api/v1/missions/') &&
        request.url.endsWith('/timeslot');
      const isExpectedMissionTimeslotError =
        (error.status === 404 || error.status === 503) && isMissionTimeslotRequest;

      if (
        message &&
        !isLoginUnauthorizedError &&
        !isDestinationNotFoundError &&
        !isExpectedExecutorTimeslotsError &&
        !isExpectedMissionTimeslotError
      ) {
        errorNotificationService.showError(message);
      }

      return throwError(() => error);
    }),
  );
};
